import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 11 класс",
        subject: "Проблемы речевой культуры",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Проблемы речевой культуры",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Хорькова Лидия Юрьевна",
                grade: "методист лаборатории филологического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>Русский язык является уникальным явлением: живой, изменчивый, восприимчивый к новым веяниям, при этом сохраняющий на протяжении веков яркость, точность, многообразие, образность, что не раз отмечалось писателями, мыслителями, учёными. Всем известны высказывания о красоте, богатстве, выразительности русского языка, любви к русскому языку  Михаила Васильевича Ломоносова, Николая Васильевича Гоголя, Ивана Сергеевича Тургенева, Константина Георгиевича Паустовского, философа Николая Александровича Бердяева и писателя Проспера Мериме.</p>
                                </div>
                                 <div style='padding: 2.4rem;'>Любовь к языку, как и любовь к природе, – составная часть патриотизма, любви к Родине. Небрежное отношение к языку, отход от национальной культуры, которая в нём выражена, не проходят бесследно для человека как личности. Ведь язык – это и основа национальной памяти, и ключ к пониманию духовного мира, своего и чужого. Важно, чтобы осознание ценности русского языка,  бережное отношение к нему, интерес к его изучению были сформированы у старшеклассников. Перед сегодняшними школьниками стоит важная   задача – овладеть богатством русского языка, совершенствовать речевую культуру.  Речевая культура – показатель одной из сторон общей культуры человека, «визитная карточка человека в обществе».</div>
                                <div style='padding: 2.4rem; padding-top: 0'>Основными тенденциями, определяющими облик современной языковой ситуации, исследователи называют снижение языковой и речевой культуры, влияние на литературный язык ненормированной разговорной речи, проникновение просторечных слов, жаргонизмов; немотивированное использование иноязычной (в основном заимствованной из американского варианта английского языка) лексики, несвойственное русскому языку интонирование, изменение тональности общения, огрубление речи. Эти негативные изменения в речевом общении зачастую не осознаются старшеклассниками как проблемы. И необходима кропотливая работа по воспитанию языкового вкуса школьников, формированию культуры использования языка во всех сферах жизни. Формирование нормативного, целесообразного, уместного, этичного употребления языковых средств; ценностного отношения школьников к родному языку – важнейший аспект преподавания русского языка в школе.</div>
                                <div style='padding: 2.4rem; padding-top: 0'>Основные задачи при изучении  темы «Проблемы речевой культуры в современном обществе»  − привлечение внимания школьников к проблемам  экологии языка, создание педагогических ситуаций для осознания обучающимися собственной роли в создании благоприятной речевой среды, формирование потребности в совершенствовании собственной речевой культуры. </div>
                                <div style='padding: 2.4rem; padding-top: 0'>Материалы методического кейса предоставляют возможность ознакомиться с факторами, которые оказывают особенно сильное влияние на речевую культуру в современном обществе, а также методическими приёмами, нацеленными на совершенствование речевой культуры учащихся.</div>`
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Галь Н. Слово живое и мёртвое. – URL: https://dramafond.ru/wp-content/uploads/2014/12/Nora_Gal_Slovo_zhivoe_i_mertvoe.pdf ",
                "Герман И. Четыре мифа о русском языке: как перестать волноваться о судьбе родной речи. – URL: https://theoryandpractice.ru/posts/9329-yazyk ",
                "Гусейнов Г.  Речь общества напоминает бороду»: что происходит с русским языком. – URL: https://www.gazeta.ru/science/2019/08/06_a_12560377.shtml ",
                "Кельдиев Т. Т. Заимствованная лексика в преподавании русского языка. – URL: http://www.gramota.ru/biblio/magazines/gramota/28_661 ",
                "Кронгауз М. Русский язык в XXI веке. – URL: https://otkrytoe-prostranstvo.ru/passed-lecture/krongauz-russkij-yazyk-v-xxi-veke/ ",
                "Кропачев Н. Русский мир: русский язык – проблемы и тенденции. – URL:  https://spbu.ru/news-events/intervyu-rektora/russkiy-yazyk-problemy-i-tendencii ",
                "Пахомов Н. Кофе на пути к среднему роду. – URL: https://lenta.ru/articles/2015/06/07/language/ ",
                "Северская О. «Языковой мир сузился до смартфона»: что беспокоит лингвистов. – URL: https://www.gazeta.ru/science/2019/08/17_a_12584209.shtml?updated ",
                "Скворцов Л. Каждый из нас в ответе за русский язык. – URL: https://textarchive.ru/c-1152376.html ",
                "Туркова К. «Апокалиптический чемоданчик»: куда катится русский язык. – URL: https://www.gazeta.ru/science/2019/09/15_a_12643111.shtml ",
                "Франко Е. П., Франко М. В. Экология языка в современном обществе. – URL: file:///C:/Users/пользователь/Downloads/ekologiya-yazyka-v-sovremennom-obschestve.pdf ",
                "Хрулева Е. Современный русский язык: катастрофы нет? – URL:  https://russkiymir.ru/publications/314261/ ",
                "Чуковский К. И. Живой как жизнь. – URL: https://chukovskiy.su/proza/zhivoj-kak-zhizn ",
                "Шаповалова И. А. Русский язык в современном мире: направления развития. – URL: https://clck.ru/34hrNT",
            ],
            filesToDownload: [
                {
                    link: "./files/task1.pdf",
                    fileName: "Дополнительные задания для учащихся (часть 1)"
                },
                {
                    link: "./files/task2.pdf",
                    fileName: "Дополнительные задания для учащихся (часть 2)"
                }
            ]
        }
    ],
};
